import { objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { Link } from 'react-router';
import { i18n } from '../../../i18n/translate.js';
import { dataAttribsForEl } from '../../../utils/dataAttribsForEl.js';
import { createPortal } from 'react-dom';
import { FAIcon } from '../../fa-icon/component.js';

var ActionDropdown = function ActionDropdown(props) {
  var renderMenuItem = function renderMenuItem(item, index, row) {
    var className = item.disabled ? 'disabled' : '';
    var dataAttributes = dataAttribsForEl(_objectSpread2(_objectSpread2({}, item.dataAttributes), {}, {
      id: row.id
    }), item.optionalAttributes);
    var content = /*#__PURE__*/React.createElement(React.Fragment, null, item.icon && /*#__PURE__*/React.createElement(FAIcon, {
      icon: item.icon
    }), " ".concat(item.title));

    if (item.actionType === 'link') {
      return /*#__PURE__*/React.createElement(Dropdown.Item, _extends({
        eventKey: index
      }, dataAttributes), /*#__PURE__*/React.createElement(Link, {
        to: item.action,
        className: className
      }, content));
    } else if (item.actionType === 'externalLink') {
      return /*#__PURE__*/React.createElement(Dropdown.Item, _extends({
        eventKey: index
      }, dataAttributes), /*#__PURE__*/React.createElement("a", {
        href: encodeURI(item.action),
        className: className
      }, content));
    } else if (item.actionType === 'callToAction') {
      return /*#__PURE__*/React.createElement(Dropdown.Item, _extends({
        onClick: function onClick(e) {
          return item.action(e, row);
        },
        eventKey: index,
        disabled: item.disabled
      }, dataAttributes), content);
    }
  };

  var onToggleDropdown = function onToggleDropdown(event) {
    if (typeof props.onToggle === 'function') {
      props.onToggle(event);
    }
  };

  var row = props.row,
      containerRef = props.containerRef;
  var dropdownMenu = /*#__PURE__*/React.createElement(Dropdown.Menu, {
    className: "super-colors ".concat(props.className)
  }, props.menuItems.map(function (item, index) {
    if (row.can_edit === false && item.type === 'edit' || row.can_delete === false && item.type === 'delete' || item.hide) ;else {
      return renderMenuItem(item, index, row);
    }
  }));
  return /*#__PURE__*/React.createElement(Dropdown, {
    onToggle: function onToggle(_, evt) {
      return onToggleDropdown(evt);
    }
  }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
    variant: "link"
  }, i18n.t('Actions'), " ", /*#__PURE__*/React.createElement(FAIcon, {
    icon: "angle-down"
  })), containerRef !== null && containerRef !== void 0 && containerRef.current ? /*#__PURE__*/createPortal(dropdownMenu, containerRef.current) : dropdownMenu);
};

ActionDropdown.displayName = "ActionDropdown";
export { ActionDropdown };